import React, { useEffect, useContext } from "react";
import { SumContext } from "../../pages/Summoner";
import { servers } from "../misc/Static";
import useFetch from "../hooks/useFetch";
import styles from "./MatchLoad.module.css";

export const MatchLoad = ({ mid, region, puuid, width }) => {
  const sc = useContext(SumContext);
  const API = `https://pp${servers[region]}.xdx.gg`;
  let data = useFetch(`${API}/match/1/${region}/${mid}/`, mid)[mid];
  useEffect(() => {
    if (data && data.puuid) {
      const pid = data.puuid.indexOf(puuid);
      const team = pid < 5 ? [0, 1, 2, 3, 4] : [5, 6, 7, 8, 9];
      const enemy = pid < 5 ? [5, 6, 7, 8, 9] : [0, 1, 2, 3, 4];
      const tk = team.reduce((t, k) => t + data.kills[k], 0);
      let teamMates = [];
      let enemies = [];
      if (data.queue !== 1700 && data.queue !== 1710) {
        team.forEach((p) => {
          if (p !== pid) teamMates.push(data.summonerName[p]);
        });
        enemy.forEach((p) => enemies.push(data.summonerName[p]));
      } else {
        const teamMatePid = pid % 2 === 0 ? pid + 1 : pid - 1;
        teamMates.push(data.summonerName[teamMatePid]);
        enemies = data.summonerName.filter(
          (name, i) => i !== pid && i !== teamMatePid
        );
      }
      const kp =
        tk > 0
          ? Math.round(((data.kills[pid] + data.assists[pid]) / tk) * 100)
          : 0;
      const sumData = {
        queue: data.queue,
        timestamp: parseInt(data.timestamp),
        duration: data.duration,
        win: data.winner[pid],
        cid: data.champion[pid],
        kills: data.kills[pid],
        deaths: data.deaths[pid],
        assists: data.assists[pid],
        kp: kp,
        lane: data.lane ? data.lane[pid] : "middle",
        minions: data.neutralMinionsKilled
          ? data.neutralMinionsKilled[pid] + data.totalMinionsKilled[pid]
          : 0,
        teamMates: teamMates,
        enemies: enemies,
      };
      sc.setSumData({ ...sc.sumData, [mid]: sumData });
      sc.setMatchData({ ...sc.matchData, [mid]: data });
    }
  }, [mid, sc, data, puuid]);
  return (
    <div
      className={styles["placeholder" + (width === "tiny" ? "tiny" : "")]}
    ></div>
  );
};
export default MatchLoad;
